export default __webpack_public_path__ + "static/media/girl4.f12b7e25.jpg";